import './css/index.css';
import 'components/download-button/css/defaults.css';
import 'components/footer';
import 'components/breadcrumbs';
import 'components/notification';
import 'components/data-explorer';
import 'components/explorer';
import 'components/data-viz-hero';
import 'components/local-navigation';
import 'components/email-notification';
import 'components/related-content-tileset';
import 'components/article-authors';
import 'components/data-download-table';
import 'components/resources-tileset';
import 'components/text-with-background-image-with-contact';
import 'components/suggested-citation';
import 'components/base-side-by-side';

import Mediator from 'js/mediator';
import Navigation from 'components/navigation';

Mediator.create( {

    componentClasses: [
        Navigation,
        {
            name: 'anchor-economy',
            module: () => import(
                'components/anchor-economy',
            ),
        },
    ],

    init() {

        console.info( 'Anchor Page has initiated.' );

    },

    ready() {

        console.info( 'Anchor Page is ready.' );

        console.info( 'Components:', this.components );

    },

} );
